import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskAccountNumber',
})
export class MaskAccountNumberPipe implements PipeTransform {
  transform(value: string | number | null | undefined, visibleDigits = 4, hidePrefix = false): string {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value);
    if (stringValue.length <= visibleDigits) {
      return stringValue;
    }

    const visiblePortion = stringValue.slice(-visibleDigits);

    return hidePrefix ? visiblePortion : '*** ***' + visiblePortion;
  }
}
